import { render, staticRenderFns } from "./UserPwdModal.vue?vue&type=template&id=77554c97&"
import script from "./UserPwdModal.vue?vue&type=script&lang=js&"
export * from "./UserPwdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports